import getToken from "@/utils/getToken";
import API from "./config";
import { mapResponse, printError } from "../utils/mapResponse";
import axios from "axios";
/**
 *  @module Reports service
 */

export default {
  /**
   * @typedef {Object} AssignmentReport
   * @property {number} courseId
   * @property {number} assignmentsTotal
   * @property {number} assignmentsOpen
   * @property {number} assignmentsStarted
   * @property {number} assignmentsCompleted
   * @property {number} assignmentsWithDueDate
   * @property {number} assignmentsDueDatePassed
   */
  /**
   * Get details on course assignments
   * @param {number} id
   * @returns {Array<AssignmentReport>}
   */
  GET_ASSIGNMENT_REPORT(id) {
    return axios
      .get(`${API.courseAssigmentsURL}${id}/assignments/summary`)
      .then(mapResponse)
      .catch(printError);
  },
};
